import React from 'react';
import { Box, Card, CardContent, Skeleton } from '@mui/material';

function SkeletonMetricCards({ count = 3 }) {
    return (
        <Box display="flex" justifyContent="center" flexWrap="wrap" gap={2} sx={{ mb: 4 }}>
            {Array.from({ length: count }).map((_, i) => (
                <Card key={i} elevation={1} sx={{ width: '200px' }}>
                    <CardContent sx={{ '&.MuiCardContent-root': { paddingBottom: '16px' } }}>
                        <Skeleton variant="rectangular" height={20} sx={{ mb: 2 }} />
                        <Skeleton variant="text" width="60%" height={40} />
                    </CardContent>
                </Card>
            ))}
        </Box>
    );
}

export default SkeletonMetricCards;

